module.exports = __webpack_public_path__ + "static/media/alexus-main.bf2e3fb2.png";